(() => {
  const businessDate = (date, count) => {
    const result = new Date(date);
    for(let i=0;i<count;){result.setDate(result.getDate()+1); if(result.getDay()!==0&&result.getDay()!==6)i++;}
    return result;
  };
  class Delivery extends HTMLElement {
    connectedCallback(){
      const min=Number(this.dataset.min),max=Number(this.dataset.max);
      if(!min||!max)return;
      const format=new Intl.DateTimeFormat(document.documentElement.lang||'en',{month:'short',day:'numeric'});
      const today=new Date();
      this.querySelector('[data-delivery-text]').textContent=`Est. delivery to ${this.dataset.country}: ${format.format(businessDate(today,min))} – ${format.format(businessDate(today,max))}`;
    }
  }
  class Accessories extends HTMLElement {
    connectedCallback(){
      this.abort=new AbortController();
      this.sync(JSON.parse(this.dataset.modelOptions||'[]'));
      this.bindForm();
      const scope=this.closest('.product-info')||this.parentElement;
      const readVariant=()=>{
        const picker=scope.querySelector(`variant-picker[form-id="${CSS.escape(this.dataset.formId)}"]`);
        const variant=JSON.parse(picker?.querySelector('[data-variant]')?.textContent||'{}');
        const signature=JSON.stringify([variant.id,variant.options]);
        if(variant.options&&signature!==this.variantSignature){this.variantSignature=signature;this.sync(variant.options);this.bindForm();}
      };
      readVariant();
      this.observer=new MutationObserver(readVariant);
      this.observer.observe(scope,{childList:true,subtree:true,characterData:true});
      document.addEventListener('change',e=>{
        if(e.target.matches('input[data-option-position]')&&e.target.getAttribute('form')===this.dataset.formId){
          const selected=[...scope.querySelectorAll('input[data-option-position]:checked')].filter(x=>x.getAttribute('form')===this.dataset.formId).sort((a,b)=>Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition)).map(x=>scope.querySelector(`label[for="${CSS.escape(x.id)}"]`)?.textContent.trim()).filter(Boolean);
          if(selected.length)this.sync(selected);
        }
      },{signal:this.abort.signal});
      document.addEventListener('variant:change',e=>{
        if(e.detail?.formId===this.dataset.formId)this.sync(e.detail.variant?.options||[]);
      },{signal:this.abort.signal});
      this.addEventListener('cart:error',e=>{
        const card=e.target.closest('.smd-accessory');if(card)card.querySelector('[role=status]').textContent=e.detail?.error||'Could not add. Please try again.';
      },{signal:this.abort.signal});
      this.addEventListener('variant:add',e=>{const card=e.target.closest('.smd-accessory');if(card)card.querySelector('[role=status]').textContent='Added to cart';},{signal:this.abort.signal});
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
    bindForm(){
      const form=document.getElementById(this.dataset.formId);
      if(!form||form===this.boundForm)return;
      this.boundForm=form;
      form.addEventListener('variant:change',e=>this.sync(e.detail?.variant?.options||[]),{signal:this.abort.signal});
      form.addEventListener('product:rerender',()=>queueMicrotask(()=>{
        const picker=document.querySelector(`variant-picker[form-id="${CSS.escape(this.dataset.formId)}"]`);
        const variant=picker?.selectedVariant||JSON.parse(picker?.querySelector('[data-variant]')?.textContent||'{}');
        this.sync(variant.options||[]);this.bindForm();
      }),{signal:this.abort.signal});
    }
    sync(options){
      const normalize=x=>String(x).trim().toLowerCase().replace(/^samsung\s+/,'').replace(/^galaxy\s+/,'').replace(/\+/g,'plus').replace(/[^a-z0-9]/g,'');
      const models=options.map(normalize);
      const family=options.some(x=>/iphone/i.test(x))?'iphone':'samsung';
      this.querySelectorAll('[data-protector]').forEach(card=>{
        const variants=JSON.parse(card.querySelector('[data-protector-variants]').textContent);
        const match=variants.find(v=>v.options.some(x=>models.includes(normalize(x))));
        card.hidden=card.dataset.family!==family;
        const input=card.querySelector('input[name=id]'),button=card.querySelector('button[type=submit]');
        input.disabled=!match?.available;button.disabled=!match?.available;
        if(match){input.value=match.id;card.querySelector('[data-accessory-fit]').textContent=match.options.join(' / ');card.querySelector('[data-accessory-price]').textContent=match.price;button.textContent=match.available?'Add':'Sold out';}
        else{card.querySelector('[data-accessory-fit]').textContent='No matching protector for this model';button.textContent='Unavailable';}
      });
    }
  }
  if(!customElements.get('smd-delivery'))customElements.define('smd-delivery',Delivery);
  if(!customElements.get('smd-accessories'))customElements.define('smd-accessories',Accessories);
})();